// extracted by mini-css-extract-plugin
module.exports =  {"button":"_373a3719ba--button--tmiJO"};